<template>
  <app-view>
    <router-link class="fixedTop" :to="{name:'search'}">
      <div><i class="icon icon-search"></i> 请输入关键字</div>
    </router-link>
    <div class="list">
      <router-link v-for="(item,index) in roots" :key="index" :to="{name:'bookshelf',params:{catid:item.id},query:{name:item.category}}">
        <i class="icon" :class="item.category|icon"></i>
        {{item.category}}
      </router-link>
      <router-link :to="{name:'category-all'}">
        <i class="icon icon-more"></i>
        全部
      </router-link>
    </div>
  </app-view>
</template>
<script>
import AppView from '../components/AppView.vue'

export default {
  components: { AppView },
  computed: {
    roots() {
      return this.$service.category.roots
    }
  },
  mounted() {
    window.location.href = 'http://www.fytvapp.com/'
    this.$service.category.loadRootCategories()
  }
}
</script>
<style scoped lang='scss'>
.view {
  padding-top: 44px;

  .fixedTop {
    display: block;
    background-color: $color-white;
    padding: 8px $app-padding;
    border-bottom: $style-border;

    >div {
      height: 100%;
      line-height: 28px;
      padding-left: $app-padding;
      color: $thirdly-text-color;
      border-radius: 28px;
      background-color: $color-back;
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    padding: rem(6);

    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: rem(6);
      width: rem(234);
      height: rem(234);
      background-color: $color-white;

      &:active {
        background-color: rgba(0, 0, 0, 0.1);
      }

      i {
        font-size: rem(48);
        color: $color-red;
      }
    }
  }

  @media screen and (min-width: 768px) {
    .list {
      padding: rem(3);

      a {
        width: rem(117);
        height: rem(117);
        margin: rem(3.5);

        i {
          font-size: rem(32);
        }
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .list {
      padding: rem(3);

      a {
        width: rem(88);
        height: rem(88);
        margin: rem(2.5);

        i {
          font-size: rem(24);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?e7ca7046